/*
 * Copyright (c) 2020 Via Transportation, Inc. All rights reserved.
 *
 * This software is distributed under license and may not be used, copied,
 * modified, or distributed without the express written permission of
 * Via Transportation, Inc.
 */

const DEV_API_URL = "https://driver-int.us1.dev.ridewithvia.com";
const EU_API_URL = "https://driver.eu1.ridewithvia.com";
const US_API_URL = "https://driver.us1.ridewithvia.com";
const CA_API_URL = "https://driver.cace1.ridewithvia.com";

export const getBaseApiUrl = (url: string) => {
    if (/dev?\.viacal\.ridewithvia\.com/.test(url)) {
        return DEV_API_URL;
    }
    if (/eu1?\.viacal\.ridewithvia\.com/.test(url)) {
        return EU_API_URL;
    }
    if (/us1?\.viacal\.ridewithvia\.com/.test(url)) {
        return US_API_URL;
    }
    if (/cace1?\.viacal\.ridewithvia\.com/.test(url)) {
        return CA_API_URL;
    }

    return DEV_API_URL;
};
